import { useFetch } from './useFetch'

export type SalesChannel = { Id: number; Name: string }

export const useSalesChannel = (
  onSuccess?: () => void,
  onErrorThrown?: () => void
) =>
  useFetch<SalesChannel[]>(
    ({ account }) =>
      `/api/proxy/catalog_system/pvt/saleschannel/list?an=${account}`,
    {},
    { onSuccess, onErrorThrown }
  )
